<template>
  <div>
    <el-card class="mb-1 box_shadow" shadow="always">
      <h5 v-if="baseInfo.scmName">{{ baseInfo.scmName }}</h5>
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <div style="height: 29px;line-height: 29px;overflow: hidden;">
            <span style="font-size: 14px; color: #606266">
              No：{{ baseInfo.hxPreOrderNo || 'New' }}
            </span>
            <el-divider direction="vertical" />
            <el-tag
              size="mini"
              :type="
                baseInfo.hxPreOrderStatus === 'D' ||
                baseInfo.hxPreOrderStatus === 'R'
                  ? 'danger'
                  : baseInfo.hxPreOrderStatus === 'Y'
                  ? 'success'
                  : baseInfo.hxPreOrderStatus === 'S'
                  ? 'warning'
                  : ''
              "
            >
              {{ baseInfo.v_hxPreOrderStatus || 'New' }}
            </el-tag>
            <el-divider direction="vertical" />
            <el-tag
              v-if="baseInfo.v_hxSkuSalesChannel"
              size="mini"
              :type="
                baseInfo.hxSkuSalesChannel === 'H'
                  ? 'success'
                  : baseInfo.hxSkuSalesChannel === 'V'
                  ? 'warning'
                  : ''
              "
            >
              {{ baseInfo.v_hxSkuSalesChannel }}
            </el-tag>
            <el-divider direction="vertical" />
            <span style="font-size: 14px; color: #606266">
              Update：{{ baseInfo.modifyByName || '--' }} at
              {{ baseInfo.modifyDate || '--' }}
            </span>
          </div>
        </div>
        <div class="switch-tabs_wrappers">
          <div class="switch-tabs">
            <div
              v-for="item in switchTabs"
              :key="item.value"
              class="switch-tabs_items"
              :class="{
                active: item.value === activeName,
                disabled: item.disabled,
              }"
              @click="!item.disabled ? (activeName = item.value) : () => {}"
            >
              <span>{{ item.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <div>
      <el-card v-show="activeName == 'base'" class="box_shadow">
        <EditForm
          ref="editForm"
          :disabled="disabled"
          :hxPreOrderCode="hxPreOrderCode"
          @loaded="(data) => (baseInfo = data)"
        />
        <div class="d-flex justify-content-between mb-2 mt-2">
          <div>
            <span style="font-size: 14px; color: #606266">
              Create：{{ baseInfo.createByName || '--' }} at
              {{ baseInfo.createDate || '--' }}
            </span>
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266">
              Submit：{{ baseInfo.submitByName || '--' }} at
              {{ baseInfo.submitTime || '--' }}
            </span>
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266">
              Review：{{ baseInfo.reviewByName || '--' }} at
              {{ baseInfo.reviewTime || '--' }}
            </span>
          </div>
          <div>
            <el-button
              v-if="!disabled"
              type="primary"
              size="small"
              @click="$refs.editForm.save()"
            >
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </div>
        </div>
      </el-card>
      <el-card v-show="activeName == 'goods'" class="box_shadow">
        <SkuTable
          :disabled="disabled"
          :hxPreOrderCode="hxPreOrderCode"
          @reload="$refs.editForm.reload()"
        />
      </el-card>
    </div>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import SkuTable from '../components/sku-table'
export default {
  name: 'ecom-hxBiz-preOrder-detail',
  components: { EditForm, SkuTable },
  data() {
    return {
      baseInfo: {},
      activeName: 'base',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
    hxPreOrderCode() {
      return this.params.hxPreOrderCode
    },
    switchTabs() {
      return [
        { label: '基本信息', value: 'base' },
        { label: '订单产品', value: 'goods', disabled: !this.hxPreOrderCode },
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
.switch-tabs {
  display: flex;
  .switch-tabs_items {
    padding: 4px 8px;
    color: #6c757d;
    font-size: 14px;
    margin-right: 20px;
    border-radius: 4px;
    cursor: pointer;
    min-width: max-content;
  }
  .switch-tabs_items:hover,
  .switch-tabs_items.active {
    color: #007bff;
    background-color: #f8f8f9;
  }
  .switch-tabs_items.disabled {
    cursor: no-drop;
  }
  .switch-tabs_items.disabled:hover {
    color: #8cc5ff;
  }
  .switch-tabs_items:last-child {
    margin-right: 0;
  }
}

::v-deep {
  .el-card__body {
    padding: 18px;
  }
}
.box_shadow {
  box-shadow: none;
}
</style>
